import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { ArrowDownIcon } from 'cokitchen-icons';
import useDashboardContext from 'contexts/dashboard.context';
import { CoKitchenType } from 'models/cokitchen.model';

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';

const CokitchenDropdown = () => {
  const { setActiveCokitchen, activeCokitchen, cokitchens, setActiveStore } = useDashboardContext();
  const navigate = useNavigate();

  const changeCokitchen = (cokitchen: CoKitchenType) => {
    setActiveCokitchen(cokitchen);
    setActiveStore(undefined);
    navigate(`/${MAIN_STORE_ROUTE_KEYS.GENERAL_STORE_DASHBOARD}`);
  };
  return (
    <Dropdown
      content={
        <div className='border border-gray-border flex gap-[.6rem] items-center leading-[40px] pl-4 pr-1 rounded-lg'>
          <span className='text-[12px] font-medium'>{activeCokitchen?.name} </span>
          <div className='rounded-full text-gray-5 cursor-pointer hover:bg-gray-1 transition-all'>
            <ArrowDownIcon />
          </div>
        </div>
      }>
      <DropdownList className='min-w-[190px]'>
        {cokitchens.map((r) => (
          <DropdownItem
            key={r.name}
            className='text-sm font-medium'
            onClick={() => changeCokitchen(r)}>
            <button className='cursor-pointer items-center flex'>{r.name}</button>
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default CokitchenDropdown;
